export default [
    {
        value: "ResolucaoNormativa",
        text: "Resolução normativa 316/2008 (Regra nova)"
    },
    {
        value: "Nao",
        text: "Não"
    },
]